import classnames from 'classnames';
import Link from '../link';
import styles from './style/split-nav-links.module.css';

const SplitNavLinks = ({ links }): JSX.Element | null => {
  if (!links || !links.length) {
    return null;
  }

  return (
    <div data-testid="split-state-nav-wrapper" className={styles.container}>
			{links.map(({ text, subCategories }) => {
        if (!subCategories || !subCategories?.length) {
          return null;
        }

        return (
          <div
            data-testid="split-state-nav-section"
            className={styles.navSection}
            key={text}>

						{text ?
            <div
              data-testid="split-state-nav-title"
              className={styles.navSectionText}>

								{text}
							</div> :
            null}
						<div
              data-testid="split-state-nav-links"
              className={styles.navSectionLinks}>

							{subCategories.map(({ text: linkText, url, isSelected }) =>
              <Link
                className={classnames(
                  styles.navSectionLink,
                  isSelected ? styles.navSectionLinkSelected : ''
                )}
                to={url}
                key={linkText}
                data-testid="split-state-nav-link">

									{linkText}
								</Link>
              )}
						</div>
					</div>);

      })}
		</div>);

};

export default SplitNavLinks;